import { Box, styled } from '@mui/material';
import { HeaderLink } from './HeaderLink';
import { HeaderLinkType } from '../Header';

const RowLinksBox = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down(924)]: {
    display: 'none',
  },
  [theme.breakpoints.up(924)]: {
    display: 'flex',
  },
  flexGrow: 1,
  justifyContent: 'space-evenly',
  gap: 25,
}));

/**
 * Appears at md breakpoint width (more than 924px)
 */
type PropsType = {
  links: HeaderLinkType[];
};

export const RowLinks = ({ links }: PropsType) => {
  return (
    <RowLinksBox>
      {links.map((link) => (
        <HeaderLink path={link.path} title={link.title} key={link.title} />
      ))}
    </RowLinksBox>
  );
};
